import { Component, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { PagareService } from 'app/services/pagare.service';
import { take } from 'rxjs';
import { FuseAlertType } from '@fuse/components/alert';
import { fuseAnimations } from '@fuse/animations';
import { ParametrosService } from 'app/services/parametros.service';

@Component({
    selector: 'plantillas',
    templateUrl: './plantillas.component.html',
    encapsulation: ViewEncapsulation.None,
    animations: fuseAnimations,
})
export class PlantillasComponent {
    alert: { type: FuseAlertType; message: string } = {
        type: 'success',
        message: '',
    };
    showAlert: boolean = false;
    plantillas: any; //REVISAR
    
    constructor(private _parametros: ParametrosService, private route: Router) {
        this._parametros
            .listarPlantillas()
            .pipe(take(1))
            .subscribe({
                next: (plantilla) => {
                    this.plantillas = plantilla;
                },
                error: (err) => {
                    console.log(err);
                    this.plantillas = [];
                },
                complete: () => {
                },
            });
    }

    goback(): void {
        this.route.navigateByUrl('home/sistema');
    }

    alertShow() {
        this.showAlert = true;
        setTimeout(() => {
            this.showAlert = false;
        }, 3000);
    }
}
